import { render, staticRenderFns } from "./ExpirationReminder.vue?vue&type=template&id=565aeec3&scoped=true&"
import script from "./ExpirationReminder.vue?vue&type=script&lang=js&"
export * from "./ExpirationReminder.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationReminder.vue?vue&type=style&index=0&id=565aeec3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565aeec3",
  null
  
)

export default component.exports